export default "__VITE_ASSET__BVahE2ej__"